/* eslint-disable import/no-cycle */
import ajax from '../../../../../../utils/ajax';

export default (url, data, method, callback, isAnonymous, aip = 'scanline') => {
	return ajax(url, data, method, callback, isAnonymous, aip);
};
